<SvgImage class="kr-flag" :template="currentIcon"></SvgImage>